(function () {
  if (window.matchMedia("(max-width: 500px)").matches) {
    let designSlider = document.querySelector(
      '[data-selector="design-slider"]'
    );

    if (designSlider) {
      const swiperDesign = new Swiper(designSlider, {
        slidesPerView: "auto",
      });

      swiperDesign.on("reachEnd", function (swiper) {
        swiper.el.classList.add("design__slider-wrap_last");
      });

      swiperDesign.on("fromEdge", function (swiper) {
        swiper.el.classList.remove("design__slider-wrap_last");
      });
    }
  }
})();
